export default [
    {
        path: '/offices',
        name: 'officesList',
        component: () => import(/* webpackChunkName: "offices" */ '../views/List.vue')
    },
    {
        path: '/offices/create',
        name: 'officesCreate',
        component: () => import(/* webpackChunkName: "offices" */ '../views/Form.vue')
    },
    {
        path: '/offices/:id/view',
        name: 'officesView',
        component: () => import(/* webpackChunkName: "offices" */ '../views/View.vue')
    },
    {
        path: '/offices/:id/edit',
        name: 'officesEdit',
        component: () => import(/* webpackChunkName: "offices" */ '../views/Form.vue')
    },
]